module.exports = __webpack_public_path__ + "static/img/2020.fd8a584.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2020.jpg
// module id = Y3iI
// module chunks = 1